import React from 'react';
import ChatBox from './ChatBox';

const Sidebar = ({ 
  gamePlayers = [], 
  playerScore = 0, 
  socket, 
  isOpen = true,
  onClose
}) => {
  // Debug logging to understand player data structure
  return (
    <div className={`${isOpen ? 'flex' : 'hidden'} flex-col fixed right-0 top-[65px] w-full xl:max-w-96 h-[calc(100vh-62px)] bg-gray-900/95 backdrop-blur-lg border-l border-gray-700/50 shadow-2xl z-40 space-y-4 p-4 transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
      {/* Players Panel */}
      <div className='bg-gray-900/80 backdrop-blur-lg rounded-2xl border border-gray-700/50 shadow-2xl flex-shrink-0'>
        <div className='border-b border-gray-700/50 p-4'>
          <div className='flex items-center justify-between'>
            <div> 
              <h3 className='text-xl font-bold text-white flex items-center gap-2'>
                <i className='fas fa-users text-cyan-400'></i>
                Players ({gamePlayers?.length || 0})
              </h3>
              <p className='text-gray-400 text-sm mt-1'>Current players in game</p>
            </div>
            <button
              onClick={onClose}
              className='p-2 text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg transition-all duration-200'
              title='Close sidebar'
            >
              <i className='fas fa-times text-lg'></i>
            </button>
          </div>
        </div>

        <div className='p-4 space-y-3 max-h-64 overflow-y-auto'>
          {!gamePlayers || gamePlayers.length === 0 ? (
            <div className='text-center py-8 text-gray-400'>
              <i className='fas fa-user-slash text-3xl mb-3'></i>
              <p className='font-medium'>No players in game</p>
              <p className='text-xs mt-2 opacity-75'>Waiting for players to join...</p>
            </div>
          ) : (
            gamePlayers.map((player, index) => {
              // Use username as stable identifier for current player detection
              const username = player.username || player.name || player.playerName || `Player ${index + 1}`;
              const playerInitial = username.charAt(0).toUpperCase();
              const playerName = username;
              
              // Get current player's username from socket service or app store
              const currentPlayerUsername = socket?.username || window.localStorage?.getItem('username') || '';
              const isCurrentPlayer = username === currentPlayerUsername;
              
              // Try multiple possible score fields
              const displayScore = isCurrentPlayer ? playerScore : (player.score || player.points || player.totalScore || 0);
              
              // console.log('🎮 Rendering player:', { 
              //   id: player.id, 
              //   username, 
              //   score: displayScore, 
              //   isCurrentPlayer,
              //   currentPlayerUsername,
              //   socketId: socket?.id 
              // });

              return (
                <div
                  key={`player-${username}-${index}`}
                  className={`flex items-center justify-between p-3 rounded-xl transition-all duration-200 ${
                    isCurrentPlayer 
                      ? 'bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 shadow-lg' 
                      : 'bg-gray-800/50 border border-gray-700/30 hover:bg-gray-800/70'
                  }`}
                >
                  <div className='flex items-center gap-3'>
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white text-sm shadow-lg ${
                      isCurrentPlayer 
                        ? 'bg-gradient-to-r from-cyan-400 to-blue-500' 
                        : 'bg-gradient-to-r from-gray-600 to-gray-700'
                    }`}>
                      {playerInitial}
                    </div>
                    <div>
                      <div className='flex items-center gap-2'>
                        <span className='text-white font-medium text-sm'>{playerName}</span>
                        {isCurrentPlayer && (
                          <span className='text-xs text-cyan-400 bg-cyan-400/10 px-2 py-0.5 rounded-full border border-cyan-400/20'>
                            You
                          </span>
                        )}
                      </div>
                      <div className='flex items-center gap-2 mt-1'>
                        <div className='flex items-center gap-1 text-xs text-emerald-400'>
                          <i className='fas fa-star text-yellow-400'></i>
                          <span>{displayScore}</span>
                        </div>
                        <div className='flex items-center gap-1 text-xs text-green-400'>
                          <div className='w-2 h-2 bg-green-400 rounded-full animate-pulse'></div>
                          <span>Online</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='flex items-center gap-2'>
                    <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                      isCurrentPlayer 
                        ? 'bg-cyan-500/20 text-cyan-300' 
                        : 'bg-emerald-500/20 text-emerald-300'
                    }`}>
                      <i className='fas fa-gamepad mr-1'></i>
                      Playing
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
        
      </div>

      {/* Chat Panel */}
      <div className='flex-1 w-full h-full'>
        <ChatBox
          socket={socket}
          className='h-full min-h-[100px]'
        />
      </div>
    </div>
  );
};

export default Sidebar;
